<template>
    <!--    component designed to make calendar.vue easier to read, not necessarily to use in other locations..-->
    <v-dialog v-model="dialog" max-width="450" persistent :fullscreen="$vuetify.breakpoint.xsOnly" scrollable>
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" rounded class="mb-1">
                <v-icon color="success">{{icons.plus}}</v-icon>
                Add
            </v-btn>
        </template>
        <v-card v-if="activeeventtime">
            <v-card-title>
                <v-avatar size="25" tile v-if="activeeventtime.src">
                    <v-img :src="activeeventtime.src" />
                </v-avatar>
                <v-text-field outlined dense class="pa-0" style="cursor: pointer" v-if="edittitle" v-model="activeeventtime.title"
                              append-outer-icon="mdi-content-save-outline"
                              @change="edittitle=false"
                              @focusout="edittitle=false"
                              @click:append-outer="edittitle=false"
                />
                <span v-else @click="edittitle=true" >{{activeeventtime.title}}</span>
                <v-spacer></v-spacer>
                <span class="font-weight-light subtitle-1">
                    {{activeeventtime.eventId}}
                </span>
            </v-card-title>
            <v-container>
                <v-row>
                    <v-col>
                        <v-card outlined>
                            <v-card-text class="subtitle-2 font-weight-light py-0">Start Time</v-card-text>
                            <v-list dense>
                                <!--     EVENT START TIME EDITING       -->
                                <v-list-item>
                                    <v-list-item-avatar size="24" class="my-0">
                                        <v-icon small>{{icons.calendar}}</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content class="py-0">
                                        <v-list-item-title>
                                            <v-menu
                                                    v-model="menu"
                                                    :close-on-content-click="true"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-btn text style="text-transform: none;" class="font-weight-light "
                                                           v-on="on">
                                                        {{startdate.toLocaleString()}}
                                                    </v-btn>
                                                </template>
                                                <v-card max-width="300">
                                                    <v-date-picker
                                                            reactive
                                                            no-title class="elevation-0"
                                                            full-width
                                                            v-model="startdate"
                                                            color="awesome lighten-1"/>
                                                </v-card>
                                            </v-menu>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-avatar size="24" class="my-0">
                                        <v-icon small>{{icons.clock}}</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content class="py-0 pl-2">
                                        <TimeDropDown :time="starttime" @timeupdate="updateStartTime($event)"/>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                    <v-col>
                        <v-card outlined>
                            <v-card-text class="subtitle-2 font-weight-light py-0">End Time</v-card-text>
                            <v-list dense>
                                <!--     EVENT END TIME EDITING       -->
                                <v-list-item>
                                    <v-list-item-avatar size="24" class="my-0">
                                        <v-icon small>{{icons.calendar}}</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content  class="py-0">
                                        <v-list-item-title>
                                            <v-menu
                                                    v-model="menu2"
                                                    :close-on-content-click="true"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-btn text style="text-transform: none;" class="font-weight-light"
                                                           v-on="on">
                                                        {{startdate}}
                                                    </v-btn>
                                                </template>
                                                <v-card max-width="300">
                                                    <v-date-picker reactive no-title class="elevation-0" full-width
                                                                   v-model="enddate"
                                                                   color="awesome lighten-1"/>
                                                </v-card>
                                            </v-menu>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-avatar size="24" class="my-0">
                                        <v-icon small>{{icons.clock}}</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content  class="py-0 pl-2">
                                        <TimeDropDown :time="endtime" @timeupdate="updateEndTime($event)"/>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <v-card-text>
                <v-textarea outlined v-if="!activeeventtime.eventId" v-model="activeeventtime.description" />
                <v-btn small @click="showcolor=true" v-if="!showcolor && !activeeventtime.eventId" text>
                    <v-icon :color="activeeventtime.color">mdi-palette</v-icon>
                </v-btn>
                <v-card outlined v-if="showcolor">
                    <v-card-text class="pa-0">
                        <v-color-picker
                                class="elevation-0"
                                mode="hexa"
                                dotsize="50"
                                hide-inputs
                                v-model="activeeventtime.color"
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small @click="showcolor=false" depressed>
                            <v-icon small>{{icons.close}}</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>

                <!--     EVENT SELECTOR       -->
                <v-list-item>
                    <v-list-item-avatar>
                        <v-icon>{{icons.calendar}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-select @change="getEventDivisions()" :items="events" v-model="activeeventtime.eventId"
                                  item-text="name" label="Select Event" item-value="id">
                            <v-list-item
                                    ripple
                            >
                                <v-list-item-avatar>
                                    <v-img :src="require('@/assets/missinggear.png')" size="20"/>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>General calendar</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <template v-slot:item="{ item }">
                                <v-list-item
                                        ripple
                                >
                                    <v-list-item-avatar>
                                        <v-img v-if="item.imgurl" :src="item.imgurl" size="20"/>
                                        <v-img v-else :src="require('@/assets/missinggear.png')" size="20"/>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{item.name}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-list-item
                                        ripple>
                                    <v-list-item-avatar>
                                        <v-img v-if="item.imgurl && item.imgurl !== null" :src="item.imgurl"/>
                                        <v-img v-else :src="require('@/assets/missinggear.png')"/>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{item.name}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-select>
                    </v-list-item-content>
                </v-list-item>

                <!--     DIVISION SELECTOR        -->
                <v-list-item v-if="divisions">
                    <v-list-item-avatar>
                        <v-icon>{{icons.list}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-select v-if="activeeventtime.tournamentId && activeeventtime.eventId"
                                  :loading="loadingdivisions" :items="divisions" v-model="activeeventtime.tournamentId"
                                  item-text="name" label="Select Division" item-value="id"/>
                        <v-list v-else>
                            <v-list-item v-for="d in divisions" :key="d.id">
                                <v-list-item-content>
                                    {{d.name}}
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-checkbox :value="d.id" v-model="multidivisions"/>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-list-item-content>
                </v-list-item>

                <!--      EDIT LINK        -->
                <v-list-item v-if="activeeventtime.eventId>0" :to="`/events/edit/${activeeventtime.eventId}`">
                    <v-list-item-avatar>
                        <v-icon>{{icons.edit}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>
                            Edit Event
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-card-text>

            <v-card-actions>
                <v-btn text @click="close()">
                    <v-icon>{{icons.close}}</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text :loading="loading" @click="saveEventTime()" :disabled="activeeventtime.start===undefined">
                    save
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="deleteTime()" :loading="deleting">Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import TimeDropDown from "./TimeDropDown";

  export default {
    components: {TimeDropDown},
    props: {
      eventtime: {
        type: Object,
        required: true,
        default() {
          return {
            "allDay": false,
            "end": false,
            "start": "",
            "title": undefined,
            "eventId": undefined,
            "festivalId": undefined,
            "tournamentId": undefined
          }
        }
      },
      activator: {
        type: Boolean,
        default: true
      }
    },
    name: "EventAdder",
    data() {
      return {
        dialog: false,
        activeeventtime: {
          "allDay": false,
          "end": false,
          "start": "",
          "title": "",
          "eventId": undefined,
          "festivalId": undefined,
          "tournamentId": undefined
        },
        menu: false,
        menu2: false,
        edittime: false,
        edittitle:false,
        showcolor:false,
        divisions: undefined,
        loading: false,
        starttime: undefined,
        startdate: undefined,
        endtime: undefined,
        enddate: undefined,
        loadingdivisions: false,
        deleting: false,
        multidivisions: [],
        times: [
          {text: "12:00 AM", value: "00:00:00.000Z"},
          {text: "12:30 AM", value: "00:30:00.000Z"},
          {text: "1:00 AM", value: "01:00:00.000Z"},
          {text: "1:30 AM", value: "01:30:00.000Z"},
          {text: "2:00 AM", value: "02:00:00.000Z"},
          {text: "2:30 AM", value: "02:30:00.000Z"},
          {text: "3:00 AM", value: "03:00:00.000Z"},
          {text: "3:30 AM", value: "03:30:00.000Z"},
          {text: "4:00 AM", value: "04:00:00.000Z"},
          {text: "4:30 AM", value: "04:30:00.000Z"},
          {text: "5:00 AM", value: "05:00:00.000Z"},
          {text: "5:30 AM", value: "05:30:00.000Z"},
          {text: "6:00 AM", value: "06:00:00.000Z"},
          {text: "6:30 AM", value: "06:30:00.000Z"},
          {text: "7:00 AM", value: "07:00:00.000Z"},
          {text: "7:30 AM", value: "07:30:00.000Z"},
          {text: "8:00 AM", value: "08:00:00.000Z"},
          {text: "8:30 AM", value: "08:30:00.000Z"},
          {text: "9:00 AM", value: "09:00:00.000Z"},
          {text: "9:30 AM", value: "09:30:00.000Z"},
          {text: "10:00 AM", value: "10:00:00.000Z"},
          {text: "10:30 AM", value: "10:30:00.000Z"},
          {text: "11:00 AM", value: "11:00:00.000Z"},
          {text: "11:30 AM", value: "11:30:00.000Z"},
          {text: "12:00 PM", value: "12:00:00.000Z"},
          {text: "12:30 PM", value: "12:30:00.000Z"},
          {text: "1:00 PM", value: "13:00:00.000Z"},
          {text: "1:30 PM", value: "13:30:00.000Z"},
          {text: "2:00 PM", value: "14:00:00.000Z"},
          {text: "2:30 PM", value: "14:30:00.000Z"},
          {text: "3:00 PM", value: "15:00:00.000Z"},
          {text: "3:30 PM", value: "15:30:00.000Z"},
          {text: "4:00 PM", value: "16:00:00.000Z"},
          {text: "4:30 PM", value: "16:30:00.000Z"},
          {text: "5:00 PM", value: "17:00:00.000Z"},
          {text: "5:30 PM", value: "17:30:00.000Z"},
          {text: "6:00 PM", value: "18:00:00.000Z"},
          {text: "6:30 PM", value: "18:30:00.000Z"},
          {text: "7:00 PM", value: "19:00:00.000Z"},
          {text: "7:30 PM", value: "19:30:00.000Z"},
          {text: "8:00 PM", value: "20:00:00.000Z"},
          {text: "8:30 PM", value: "20:30:00.000Z"},
          {text: "9:00 PM", value: "21:00:00.000Z"},
          {text: "9:30 PM", value: "21:30:00.000Z"},
          {text: "10:00 PM", value: "22:00:00.000Z"},
          {text: "10:30 PM", value: "22:30:00.000Z"},
          {text: "11:00 PM", value: "23:00:00.000Z"},
          {text: "11:30 PM", value: "23:30:00.000Z"}
        ],
      }
    },
    computed: {
      ...mapState(['org', 'icons', 'events']),
      friendlydate() {
        return new Date(this.activeeventtime.start).toUTCString()
      },
    },
    watch: {
      dialog(n) {
        if (!n) this.reset()
      },
      eventtime(n) {
        console.log('N',n)
        //ISO format 2020-09-09T23:00:00.000Z
        //ISO format 2020:08:08T16:00:00:000Z
        this.activeeventtime = Object.assign({}, n)
        let dt = new Date(n.start)
        let yr = dt.getFullYear()
        let dy = dt.getDate()
        let mt = dt.getMonth() + 1;
        mt = (mt > 9) ? mt : '0' + mt
        dy = (dy > 9) ? dy : '0' + dy
        this.startdate =  n.dstring.split('T')[0]  //// yr + '-' + mt + '-' + dy
        let hr = dt.getHours()
        hr = (hr > 9) ? hr : '0' + hr
        let mn = dt.getMinutes()
        mn = (mn > 9) ? mn : '0' + mn
        this.starttime = n.dstring.split('T')[1]  /// hr + ':' + mn + ':' + '00'
        if (n.end) {
          let edt = new Date(n.end)
          yr = edt.getFullYear()
          dy = edt.getDate()
          mt = edt.getMonth() + 1
          mt = (mt > 9) ? mt : '0' + mt
          dy = (dy > 9) ? dy : '0' + dy
          this.enddate =  yr + '-' + mt + '-' + dy
          let hr = edt.getHours()
          hr = (hr > 9) ? hr : '0' + hr
          let mn = edt.getMinutes()
          mn = (mn > 9) ? mn : '0' + mn
          this.endtime = hr + ':' + mn + ':' + '00'
        } else {
          let edt = new Date(n.start)
          edt.setHours(dt.getHours() + 1)
          yr = edt.getFullYear()
          dy = edt.getDate()
          mt = edt.getMonth() + 1
          mt = (mt > 9) ? mt : '0' + mt
          dy = (dy > 9) ? dy : '0' + dy
          this.enddate = yr + '-' + mt + '-' + dy
          let hr = edt.getHours()
          hr = (hr > 9) ? hr : '0' + hr
          let mn = edt.getMinutes()
          mn = (mn > 9) ? mn : '0' + mn
          this.endtime = hr + ':' + mn + ':' + '00'
        }
        this.dialog = true
        if (n.tournamentId) {
          this.getEventDivisions()
        }
      },
      enddate() {
        let end = this.enddate + 'T' + this.endtime
        this.activeeventtime.end = end;
      },
      endtime() {
        if (!this.enddate) {
          this.enddate = this.startdate
        }
        let end = this.enddate + 'T' + this.endtime
        this.activeeventtime.end = end;
      }
    },
    mounted() {
      this.startdate = this.eventtime.start.split('T')[0]
      this.starttime = this.eventtime.start.split('T')[1]
      if (!this.events.length) this.getEvents
    },
    methods: {
      ...mapActions(['getDivisions', 'post', 'getEvents']),
      async reset() {
        let d = new Date();
        this.activeeventtime = {
          "allDay": false,
          "end": null,
          "start": d.toISOString(),
          "title": "",
          "eventId": undefined,
          "festivalId": undefined,
          "tournamentId": undefined
        }
      },
      updateStartTime(e) {
        this.starttime = e
      },
      updateEndTime(e) {
        this.endtime = e
      },
      async saveEventTime() {
        this.activeeventtime.allDay = !!this.activeeventtime.allDay
        let start = this.startdate + 'T' + this.starttime
        this.activeeventtime.start = start;

        if (!this.activeeventtime.end) {
          let end = new Date(start)
          end.setHours(end.getHours() + 1)
          this.activeeventtime.end = end
        } else {
          let end = this.enddate + 'T' + this.endtime
          this.activeeventtime.end = end;
        }
        if (this.multidivisions.length > 0) {
          this.activeeventtime.multidivisions = this.multidivisions
        } else {
          this.activeeventtime.multidivisions = false
        }
        this.loading = true;

        //return;
        await this.post({path: 'api/caltimes/savetimev2', body: this.activeeventtime})
        this.loading = false;
        this.close()
      },
      async repete() {
        this.activeeventtime.repete = 3
        await this.post({path: 'api/caltimes/duplicatetimev2', body: this.activeeventtime})
        this.close()
      },
      async deleteTime() {
        this.deleting = true
        await this.post({path: 'api/caltimes/deletetime', body: this.activeeventtime})
        this.deleting = false
        this.close()
      },
      async close() {
        this.divisions = undefined
        this.multidivisions = []
        this.edittime = false
        this.dialog = false
        this.loading = false
        this.deleting = false
        this.edittitle=false
        this.showcolor=false
        this.$emit('done')
      },
      async getEventDivisions() {
        this.loadingdivisions = true;
        let data = await this.getDivisions({eventid: this.activeeventtime.eventId})
        this.loadingdivisions = false
        if (data.length > 0) {
          this.divisions = data
        } else {
          this.divisions = undefined
        }
      }
    }
  }
</script>

<style scoped>

</style>